var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('press-center',{attrs:{"in-category":915,"current-url":"Coral Club","in-name":"coral_club"}})}
var staticRenderFns = []

export { render, staticRenderFns }